import { Link } from 'react-router-dom';
import { useGameDestination } from '@/components/accountRecord/gameDestination';

/** #1184: for a held Kalshi position (`onViewRecord` set) the notice offers its
 *  read-only account record, and `href` becomes a candidate: "Open event
 *  details" shows only while the live store resolves the game (or for a
 *  non-Game-Detail destination), so a settled card no longer links to an empty
 *  Game Detail. Every other notice (Polymarket, US, an unheld ticker) keeps
 *  its link exactly as before. */
export function UnavailableCardBookNotice({ ticker, href, onDismiss, onViewRecord }: {
  ticker: string;
  href: string | null;
  onDismiss: () => void;
  onViewRecord?: (trigger: HTMLElement) => void;
}) {
  const destination = useGameDestination(onViewRecord ? href : null, ticker);
  const linkHref = onViewRecord ? (destination.kind === 'absent' ? null : destination.href) : href;
  return (
    <div role="status" aria-label="Selected contract unavailable" className="border-border bg-card flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-b px-6 py-2 text-sm">
      <span>Book unavailable for this contract. The previous trade panel is closed.</span>
      {linkHref && <Link className="text-primary underline" to={linkHref}>Open event details</Link>}
      {onViewRecord && (
        <button type="button" className="text-primary underline" onClick={(e) => onViewRecord(e.currentTarget)}>View record</button>
      )}
      <button type="button" className="text-muted-foreground ml-auto underline" onClick={onDismiss}>Dismiss</button>
      <span className="text-muted-foreground basis-full break-all font-mono text-xs">{ticker}</span>
    </div>
  );
}
